import { render, staticRenderFns } from "./miniatureData.vue?vue&type=template&id=7509dc40&lang=pug&"
import script from "./miniatureData.vue?vue&type=script&lang=js&"
export * from "./miniatureData.vue?vue&type=script&lang=js&"
import style0 from "./miniatureData.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports